<template>
  <div>
    <div class="content">
      <!--头部-->
      <div class="techDetails__headBg">
        <img
          class="techDetails__head_img border"
          style="width:3rem;height:3rem;"
          :src="tech.thumb?tech.thumb:tech.avatar"
          alt
          @click="previewImage(tech.thumb?tech.thumb:'/static/img/tech_avater.png')"
        />
        <p class="fs_15 col_666">{{tech.name}}</p>
        <p
          :class="['technician_status',tech.status==2?'technicial_status_bg':'']"
        >{{tech.status==2?'休息':'工作'}}</p>
        <van-rate
          v-model="star_num"
          allow-half
          void-icon="star"
          void-color="#ccc"
          size="11px"
          gutter="2px"
          readonly
        />
        <div>
          <p>级别：{{levelname}}</p>
          <p>个人编号：{{tech.num_id}}</p>
        </div>
        <!-- <div class="tech_tagBox">
          <span v-for="(item,index) in tech_tag" :key="index">{{item}}</span>
        </div>-->
      </div>
      <!-- 简介-->
      <div class="mb_5 storeDetails__intro">
        <div class="intro_title">
          <span class="title__tag">简介</span>
        </div>
        <div class="intro_content">
          <div :class="[boxshow?'':'auto_hide']">{{tech.desc}}</div>
          <transition name="draw">
            <!--这里的name 和 css 类名第一个字段要一样-->
            <div class="show__content" v-show="boxshow">
              <div class="show__content_list">
                <p>
                  <label class="col_333">从业时间</label>
                  <span>{{tech.workingtime}}年</span>
                </p>
              </div>
              <div class="show__content_list">
                <p>
                  <label class="col_333">从业经历</label>
                </p>
                <!-- <p><span>2009年-2015年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安顺中医馆</span></p>
                <p><span>2009年-2015年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安顺中医馆</span></p>
                <p><span>2009年-2015年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安顺中医馆</span></p>-->
                <p>
                  <span>{{tech.work_experience}}</span>
                </p>
              </div>
            </div>
          </transition>
          <!--下拉展示更多-->
          <div class="center">
            <button class="down__moreBtn" @click="boxshow = !boxshow">
              <van-icon v-if="!boxshow" name="arrow-down" />
              <van-icon v-if="boxshow" name="arrow-up" />
            </button>
          </div>
        </div>
      </div>
      <div class="mb_5">
        <van-cell :value="tech_monthcount+'单'" value-class="col_45B9BC">
          <template slot="title">
            <span class="custom-title title__tag">月服务单数</span>
          </template>
        </van-cell>
      </div>
      <div class="mb_5">
        <van-cell :value="tech.score+'分'" value-class="col_45B9BC" @click="jump_comment()">
          <template slot="title">
            <span class="custom-title title__tag">评价</span>
            <span class="col_999 fs_12">({{tech.comment_total}})</span>
          </template>
        </van-cell>
      </div>
      <!-- 服务项目-->
      <div class="mb_5 storeDetails__intro">
        <div class="intro_title">
          <span class="title__tag">服务项目</span>
        </div>
        <div class="techDetails__itemBox">
          <router-link
            :to="{path:'/itemDetails',query:{service_id:item.id,tech_id:tech_id,store_id:store_id}}"
            class="storeList flex_center bt_1"
            v-for="(item,index) in tech.service"
            :key="index"
          >
            <div class="storeList__img itemList__img">
              <img :src="item.thumb_frist" alt />
            </div>
            <div class="storeList__content">
              <div>{{item.title}}</div>
              <div class="col_999 fs_12 mb_5 one">{{item.desc}}</div>
              <div class="itemList_price fs_12">
                <span>¥{{item.tech_price?item.tech_price:item.price}}</span>
                {{item.tech_itemtime?item.tech_itemtime:item.itemtime}}分钟/次
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 底部组件-->
    <bookFooter :tech_id="tech_id"></bookFooter>
  </div>
</template>

<script>
import bookFooter from "@/components/bookFooter";
export default {
  name: "technicianDetails",
  components: { bookFooter },
  data() {
    return {
      tech_id: 0,
      tech: [],
      levelname: "",
      store_id: 0,
      star_num: 0, //点亮星星数量
      tech_grade: "", //技师级别
      perNum: "", //个人编号
      // tech_tag:['颈椎按摩','腰部按摩','足部按摩'],   //技师标签 现在不需要了
      boxshow: false,
      // 简介内容
      intro_content: "",
      //项目列表
      itemList: [
        // {img:"/static/img/itemList_img1.png",title:"体验按摩",content:"极致推拿，给身体一次彻底的解放极致推拿，给身体一次彻底的解放",price:"39.00",time:"15"},
        // {img:"/static/img/itemList_img2.png",title:"体验按摩",content:"极致推拿，给身体一次彻底的解放....",price:"39.00",time:"15"},
        // {img:"/static/img/itemList_img3.png",title:"体验按摩",content:"极致推拿，给身体一次彻底的解放....",price:"39.00",time:"15"},
      ],
      urls: [],
      tech_monthcount: 0
    };
  },
  created() {
    this.tech_id = this.$route.query.tech_id;
    this.store_id = this.$route.query.store_id;
    this.axios({
      url: this.api.tech.tech_detail,
      data: {
        tech_id: this.tech_id,
        store_id: this.store_id
      }
    }).then(res => {
      if (res.error === 0) {
        let p = new Promise((resolve, reject) => {
          this.tech = res.tech;
          this.head_img = res.tech.thumb ? res.tech.thumb : res.tech.avatar;
          this.star_num = Math.round(res.tech.score);
          this.levelname = res.tech.level.title;
          this.tech_monthcount = res.tech_monthcount;
          console.log(this.head_img);
          resolve("成功");
        });
        p.then(data => {
          this.share();
        });
      }
    });
  },
  methods: {
    jump_comment() {
      if (this.tech.comment_total > 0) {
        this.$router.push({
          path: "/evaluate",
          query: { tech_id: this.tech.id }
        });
      }
    },
    previewImage(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: [url] // 需要预览的图片http链接列表
      });
    },
    share() {
      this.axios({
        url: this.api.index.shareconfig
      }).then(res => {
        if (res.error === 0) {
          this.wx.wxShare({
            title: this.tech.name,
            desc: res.shareconfig.desc,
            imgUrl: this.tech.thumb,
            link: window.location.href,
            toast: "hide"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/store.css";
@import "../../../assets/css/item.css";
@import "../../../assets/css/technician.css";
/*服务项目*/
.storeList {
  margin-bottom: 0;
  padding-left: 0;
}
.auto_hide {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.technician_status {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  /* padding: 0.2rem 0.5rem; */
  width: 2.5rem;
  text-align: center;
  margin: auto;
  font-size: 0.6rem;
}
.technicial_status_bg {
  background-color: #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/views/book/technician/technicianDetails.vue